"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colours = require("../../theme/colours");

var _default = {
  ProgressBarContainer: {
    width: '100%',
    fontSize: '10px',
    fontWeight: 500,
    color: _colours.colours['raisin']
  },
  TextContainer: {
    marginTop: '0px',
    marginRight: '0px',
    display: 'flex',
    justifyContent: 'space-between'
  },
  ProgressBar: {
    height: '13px',
    width: '100%',
    marginBottom: '0px',
    borderRadius: '8px',
    backgroundColor: _colours.colours['wolf'],
    overflow: 'hidden',

    /* gets rid of default border in Firefox and Opera. */
    border: 'none',

    /* Polyfill */
    '&[role]:after': {
      backgroundImage: 'none'
      /* removes default background from polyfill */

    },

    /* Ensure fallback text doesn't appear in polyfill */
    '&[role] strong': {
      display: 'none'
    },

    /* Chrome, Safari */
    '&::-webkit-progress-bar': {
      borderRadius: '8px',
      backgroundColor: _colours.colours['wolf'],
      overflow: 'hidden'
    },
    '&::-webkit-progress-value': {
      borderRadius: '8px',
      backgroundColor: function backgroundColor(_ref) {
        var props = _ref.props;
        return props['colour'] || _colours.colours['azure'];
      }
    },

    /* Firefox */
    '&::-moz-progress-bar': {
      borderRadius: '8px',
      backgroundColor: function backgroundColor(_ref2) {
        var props = _ref2.props;
        return props['colour'] || _colours.colours['azure'];
      },
      overflow: 'hidden'
    }
  }
};
exports["default"] = _default;
//# sourceMappingURL=style.js.map